// Complete the Look — pre-select variants & sync price to button
(function () {
  document.querySelectorAll('.ctl-card').forEach(function (card) {
    var variants = card.querySelector('product-variants');
    if (!variants) return;

    // Pre-check radios matching the selected variant options
    var selected = variants.dataset.selectedOptions;
    if (selected) {
      var options = selected.split('|||');
      var groups = variants.querySelectorAll('[data-js-product-variant]');
      groups.forEach(function (group, i) {
        if (!options[i]) return;
        var radios = group.querySelectorAll('.product-variant__input');
        radios.forEach(function (radio) {
          if (radio.value === options[i]) {
            radio.checked = true;
          }
        });
      });
    }

    // Sync price to button on variant change
    var priceId = 'product-price-' + variants.dataset.id;
    var src = document.getElementById(priceId);
    var btn = card.querySelector('[data-ctl-button-price]');
    var sep = card.querySelector('.ctl-card__button-sep');
    if (!src || !btn) return;
    variants.addEventListener('VARIANT_CHANGE', function () {
      var original = src.querySelector('[data-js-product-price-original]');
      if (original) {
        var txt = original.textContent.trim();
        btn.textContent = txt;
        if (sep) sep.style.display = txt ? '' : 'none';
      }
    });
  });
})();
